var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptimizedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.15909L13.3364 5.25682L13.5682 2.74091L11.1068 2.18182L9.81818 0L7.5 0.995455L5.18182 0L3.89318 2.175L1.43182 2.72727L1.66364 5.25L0 7.15909L1.66364 9.06136L1.43182 11.5841L3.89318 12.1432L5.18182 14.3182L7.5 13.3159L9.81818 14.3114L11.1068 12.1364L13.5682 11.5773L13.3364 9.06136L15 7.15909ZM6.19773 10.3773L3.60682 7.77955L4.61591 6.77045L6.19773 8.35909L10.1864 4.35682L11.1955 5.36591L6.19773 10.3773Z",
    fill: "#12C971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizedIcon);
export default __webpack_public_path__ + "static/media/OptimizedIcon.f7082c62520d6641c0839b40c1413e67.svg";
export { ForwardRef as ReactComponent };